<template>
    <div class="medicine-analysis">
        <div v-if="hasSankey" class="chart-card sankey-card">
            <p class="chart-card-tit">用药桑基图</p>
            <disease-chart :option="sankeyOption" height="360px" />
        </div>
        <div v-if="topCharts.length" class="medicine-grid">
            <div v-for="item in topCharts" :key="item.field" class="chart-card">
                <p class="chart-card-tit">{{ item.title }} Top10</p>
                <disease-chart :option="item.option" height="300px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import { MEDICINE_TYPES } from '../doctorData';
import { buildSankeyOption } from './buildSankeyOption';

const BAR_COLORS = ['#165DFF', '#7c3aed', '#db2777', '#ea580c', '#059669', '#0F766E'];

function buildBarOption(list, color) {
    const data = [...list].reverse();
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
        },
        grid: {
            left: 16,
            right: 40,
            top: 8,
            bottom: 8,
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            splitLine: { lineStyle: { type: 'dashed', color: '#E8EEF8' } },
            axisLabel: {
                color: '#5A6779',
                hideOverlap: true,
                margin: 10,
            },
        },
        yAxis: {
            type: 'category',
            data: data.map((item) => item.name),
            axisTick: { show: false },
            axisLine: { lineStyle: { color: '#E8EEF8' } },
            axisLabel: {
                color: '#333',
                fontSize: 12,
                width: 120,
                overflow: 'truncate',
                margin: 10,
            },
        },
        series: [
            {
                type: 'bar',
                data: data.map((item) => item.value),
                barWidth: 14,
                barCategoryGap: '36%',
                itemStyle: {
                    color,
                    borderRadius: [0, 6, 6, 0],
                },
                label: {
                    show: true,
                    position: 'right',
                    color: '#5A6779',
                    fontSize: 11,
                    distance: 6,
                },
            },
        ],
    };
}


export default {
    name: 'MedicineAnalysis',
    components: {
        DiseaseChart,
    },
    props: {
        chartData: { type: Object, default: () => ({}) },
    },
    computed: {
        hasSankey() {
            // 节点由 buildSankeyOption 从 links 自动提取，接口 data 缺失时只要有连线也应渲染。
            const sankey = this.chartData.sankey;
            return !!(sankey && ((sankey.data && sankey.data.length) || (sankey.links && sankey.links.length)));
        },
        sankeyOption() {
            // 连线在 sankey.links，节点由 buildSankeyOption 自动提取。
            return buildSankeyOption(this.chartData.sankey || {});
        },
        topCharts() {
            return MEDICINE_TYPES.map((item, index) => {
                const list = this.chartData[item.field] || [];
                return { ...item, hasData: list.length > 0, option: buildBarOption(list, BAR_COLORS[index]) };
            }).filter((item) => item.hasData);
        },
    },
};
</script>

<style lang="less" scoped>
.medicine-analysis {
    .sankey-card { margin-bottom: 16px; }
    .medicine-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
    }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;


    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
